import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberDisplay from '../../../../components/number-display';
import MoneyDisplay from '../../../../components/money-display';

class StageCellRendered extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.hanldeClick = this.hanldeClick.bind(this);
  }

  hanldeClick(opportunities) {
    this.props.onSelect(opportunities);
  }

  renderStat(value, opportunities, cls) {
    if (value === null) {
      return null;
    }
    const comp = (<span className={cls}><MoneyDisplay value={value} abbreviated /></span>);
    if (opportunities && opportunities.length) {
      return (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.hanldeClick(opportunities);
          }}
        >
          {comp}
        </a>
      );
    }
    return comp;
  }

  renderPercentage(value, percentage = null, opportunities = null, cls = null) {
    if (value === null) {
      return (<span className="text-muted">N/A</span>);
    }
    const comp = <span className={`label ${cls}`}><NumberDisplay value={(percentage * 100)} suffix="%" precision={1} /></span>;
    if (opportunities && opportunities.length) {
      return (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.hanldeClick(opportunities);
          }}
        >
          {comp}
        </a>
      );
    }
    return comp;
  }

  render() {
    const { stats, data, isProjectedSales, rowType } = this.props;
    if (data.skip_conversion) {
      return (<span className="text-muted text-center">&nbsp;</span>);
    }

    let s = null;
    if (isProjectedSales) {
      s = stats;
    } else {
      s = stats && stats.stages ? stats.stages[data.value] : null;
    }
  
    let total = null;
    let bigAmount = null;
    let bigPercentage = null;
    let oldAmount = null;
    let oldPercentage = null;
    let totalOpportunities = [];
    let bigOpportunities = [];
    let oldOpportunities = [];

    if (s) {
      total = isProjectedSales ? s.totalProjectedSales : s.totalAmount;
      bigAmount = isProjectedSales ? s.bigProjectedSales : s.bigAmount;
      bigPercentage = isProjectedSales ? s.bigProjectedSalesPercentage : s.bigAmountPercentage;
      oldAmount = isProjectedSales ? s.oldProjectedSales : s.oldAmount;
      oldPercentage = isProjectedSales ? s.oldProjectedSalesPercentage : s.oldAmountPercentage;
      ({ totalOpportunities, bigOpportunities, oldOpportunities } = s);
    }

    if (rowType === 'total') {
      return (
        <div className="text-right">
          {total !== null && this.renderStat(total, totalOpportunities)}
          {total === null && <span className="text-muted">N/A</span>}
        </div>
      );
    }
    if (rowType === 'big') {
      return (
        <div className="clearfix">
          <div className="pull-right text-right" style={{ width: 50 }}>{this.renderPercentage(bigAmount, bigPercentage, bigOpportunities, 'label-success')}</div>
          <div className="pull-right text-right">{this.renderStat(bigAmount, bigOpportunities, 'text-success')}</div>
        </div>
      );
    }

    if (rowType === 'old') {
      return (
        <div className="clearfix">
          <div className="pull-right text-right" style={{ width: 50 }}>{this.renderPercentage(oldAmount, oldPercentage, oldOpportunities, 'label-danger')}</div>
          <div className="pull-right text-right">{this.renderStat(oldAmount, oldOpportunities, 'text-danger')}</div>
        </div>
      );
    }
    

    return (<div>&nbsp;</div>);
  }
}

StageCellRendered.propTypes = {
  stats: PropTypes.shape({
  }),
  data: PropTypes.shape({
    value: PropTypes.string,
    skip_conversion: PropTypes.bool,
  }).isRequired,
  isProjectedSales: PropTypes.bool,
  rowType: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
};
StageCellRendered.defaultProps = {
  stats: null,
  isProjectedSales: false,
  onSelect: () => {},
};
export default StageCellRendered;
